module.exports = __webpack_public_path__ + "d08bc9884a825ee65ee7af450009bf41.svg";